export default __webpack_public_path__ + "static/benefitSectionBg-18f3aa78b41702d1f43306d8cdeb1aec.png";